// extracted by extract-css-chunks-webpack-plugin
module.exports = {"alert-box":"alert-box","alert-message":"alert-message","alert-close-button":"alert-close-button","alert-icon":"alert-icon","hide-alert":"hide-alert"};